import * as actionTypes from "../actions/actionTypes";

export const loginSuccessUserInfo = (payload) => {
    return {
      type: actionTypes.LOGIN_SUCCESS_USERINFO,
      login_agent_data_info: payload,
    };
  };

